/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Snapshot } from "./Snapshot";
export const SnapshotsResponse = core.serialization.object({
    data: core.serialization.list(Snapshot),
});
